module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 62
// module chunks = 1